import * as ko from "knockout";
import { searchCriteria } from "organized";

export class RequestSearchCriteria extends searchCriteria {
  page_dir: KnockoutObservable<string>;
  created_dttm_last_value: KnockoutObservable<Date>;
  sort_field_last_value: KnockoutObservable<string>;
  request_id: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm_from: KnockoutObservable<Date>;
  created_dttm_to: KnockoutObservable<Date>;
  req_status: KnockoutObservable<string>;
  req_class: KnockoutObservable<string>;
  req_type: KnockoutObservable<string>;

  model_id: KnockoutObservable<string>;
  user_def2: KnockoutObservable<string>;
  user_def3: KnockoutObservable<string>;
  user_def13: KnockoutObservable<string>;
  spare_part_invoice_no: KnockoutObservable<string>;
  contact_name: KnockoutObservable<string>;
  selected_place: KnockoutObservable<string>;
  is_related_to_product: KnockoutObservable<boolean>;
  user_locale: KnockoutObservable<string>;
  inc_state: KnockoutObservable<any>;
  page_type: KnockoutObservable<string>;
  sw_module: KnockoutObservable<string>;

  constructor(item) {
    super(item);
    this.contact_name = ko.observable(item.contact_name);
    this.selected_place = ko.observable(item?.selected_place);
    this.request_id = ko.observable(item.request_id);
    this.created_by = ko.observable(item.created_by);
    this.req_status = ko.observable(item.req_status);
    this.req_class = ko.observable(item.req_class);
    this.req_type = ko.observable(item.req_type);
    this.created_dttm_from = ko.observable(this.formatJSONDate(item.created_dttm_from));
    this.created_dttm_to = ko.observable(this.formatJSONDate(item.created_dttm_to));
    this.page_dir = ko.observable(item.page_dir);
    this.sort_field_last_value = ko.observable(item.sort_field_last_value);
    this.created_dttm_last_value = ko.observable(item.created_dttm_last_value);

    this.model_id = ko.observable(item.model_id);
    this.user_def2 = ko.observable(item.user_def2);
    this.user_def13 = ko.observable(item.user_def13);
    this.user_def3 = ko.observable(item.user_def3);
    this.user_def3.subscribe((newval) => {
      if (newval != "SPAREPART") {
        this.spare_part_invoice_no = ko.observable();
      }
    });
    this.spare_part_invoice_no = ko.observable(item.spare_part_invoice_no);
    this.is_related_to_product = ko.observable(item?.is_related_to_product ?? false);
    this.user_locale = ko.observable(item?.user_locale);
    this.inc_state = ko.observable(item?.inc_state);
    this.page_type = ko.observable(item?.page_type);
    this.sw_module = ko.observable(item?.sw_module);
  }
}
